import { motion } from "framer-motion";

const lines = ["Une seule équipe.", "Une seule stratégie.", "Un seul objectif."];

/**
 * Section de différenciation — volontairement minimaliste.
 * Beaucoup d'espace négatif, aucune carte, aucun bouton.
 */
const DifferentiationV2 = () => {
  return (
    <section
      aria-labelledby="differenciation-titre"
      className="bg-background py-16 md:py-44"
    >
      <div className="mx-auto max-w-5xl px-5 md:px-8">
        <motion.h2
          id="differenciation-titre"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl text-balance text-[1.7rem] font-medium leading-[1.18] tracking-tight md:text-5xl md:leading-[1.1]"
        >
          Une entreprise ne devrait pas avoir besoin de cinq fournisseurs pour
          faire fonctionner son marketing.
        </motion.h2>

        <div className="mt-8 space-y-2 md:mt-20 md:space-y-5">
          {lines.map((line, i) => {
            const isLast = i === lines.length - 1;
            return (
              <motion.p
                key={line}
                initial={{ opacity: 0, y: 14 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{
                  duration: 0.7,
                  delay: 0.15 + i * 0.25,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className={`text-lg md:text-3xl ${
                  isLast ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {line}
              </motion.p>
            );
          })}
        </div>

        <p className="mt-10 max-w-3xl text-sm leading-relaxed text-muted-foreground md:mt-20 md:text-base">
          Agence 80/20 est une agence marketing basée à Montréal qui accompagne les entreprises de
          services au Québec dans la création de systèmes de croissance combinant stratégie, contenu,
          publicité, génération de leads et suivi.
        </p>
      </div>
    </section>
  );
};


export default DifferentiationV2;
